// Opens Dawn's slide-in cart drawer after the Zepto personalizer adds a product.
//
// The byRavn PDP "add to cart" is owned by the Zepto app, not the theme: its form has
// no <product-form> wrapper, so Dawn's drawer-opening logic never runs. With Zepto's
// "Action after add to cart" set to "Stay on the product page", nothing reopens the
// cart, so we listen for Zepto's AJAX add (jQuery → XHR POST to /cart/add[.js]) and
// refresh + open the existing <cart-drawer> via its own renderContents().
//
// Scoped to XHR because that is Zepto's transport; the theme's own fetch-based adds
// already open the drawer themselves, so we deliberately do not touch fetch here.
(function () {
  if (window.__byRavnCartDrawerBridge) return;
  window.__byRavnCartDrawerBridge = true;

  const ADD_URL = /\/cart\/add(\.js)?(\?|$)/;
  const CHANGE_URL = /\/cart\/change(\.js)?(\?|$)/;
  const OPEN_DEBOUNCE_MS = 250;

  let openTimer = null;

  function scheduleOpen() {
    clearTimeout(openTimer);
    openTimer = setTimeout(openDrawer, OPEN_DEBOUNCE_MS);
  }

  async function openDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    // When the add carries a theme-charged engraving fee, byRavn-gravering.js is
    // mid-reconcile right now (it set `settling` in the same zepto-add dispatch that
    // scheduled this open). Wait it out so the drawer's first paint already shows the
    // fee child folded in, instead of flashing the stale amounts and repainting.
    // Resolved promptly on every reconcile outcome, plus a failsafe timeout there.
    try {
      const gravering = window.byRavnGravering;
      if (gravering && gravering.settling) await gravering.settling;
    } catch (error) {
      /* open regardless — the drawer must never stay shut over a fee repaint */
    }

    try {
      const response = await fetch(`${window.routes.cart_url}?sections=cart-drawer,cart-icon-bubble`);
      const sections = await response.json();
      drawer.renderContents({ sections });
    } catch (error) {
      drawer.open();
    }
  }

  const nativeOpen = XMLHttpRequest.prototype.open;
  const nativeSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__brMethod = (method || '').toUpperCase();
    this.__brUrl = url || '';
    return nativeOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this.__brMethod === 'POST' && ADD_URL.test(this.__brUrl)) {
      this.addEventListener('loadend', () => {
        if (this.status < 200 || this.status >= 300) return;
        // Zepto attaches its preview property out-of-band, after this add returns.
        // Broadcast so byRavn-cart-preview-strip.js can sweep once Zepto has settled —
        // this file owns the XHR patch, everyone else listens rather than patching again.
        // detail.item carries the added line as /cart/add.js returned it (single-item
        // form add ⇒ the line object itself) so byRavn-gravering.js can gate on the
        // response without a second fetch; null when the body isn't parseable.
        let item = null;
        try {
          item = JSON.parse(this.responseText);
        } catch {
          item = null;
        }
        document.dispatchEvent(new CustomEvent('byRavn:zepto-add', { detail: { item } }));
        scheduleOpen();
      });
    }
    // Zepto also rewrites the added line's property set (re-keying it) a moment after
    // the add. byRavn-gavepose.js holds its toggle until this lands — broadcast it.
    if (this.__brMethod === 'POST' && CHANGE_URL.test(this.__brUrl)) {
      this.addEventListener('loadend', () => {
        if (this.status < 200 || this.status >= 300) return;
        document.dispatchEvent(new CustomEvent('byRavn:zepto-change'));
      });
    }
    return nativeSend.apply(this, arguments);
  };
})();
